<section class="main-container">
  <router-outlet></router-outlet>
</section>
<div id="cf-turnstile-overlay" class="cf-turnstile-overlay" hidden>
  <div class="cf-turnstile-panel" role="dialog" aria-modal="true" aria-labelledby="cf-turnstile-title">
    <p id="cf-turnstile-title">Confirme que você é humano</p>
    <div id="cf-turnstile-host"></div>
  </div>
</div>